export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="DASOFT">
      <defs>
        <linearGradient id="dasoftGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2563EB" />
          <stop offset="1" stopColor="#38BDF8" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill="#070B12" />
      <path
        d="M20 15 H31.5 C41.3 15 49 22.6 49 32 C49 41.4 41.3 49 31.5 49 H20 Z M29 23.5 H31.5 C36.3 23.5 40.5 27.2 40.5 32 C40.5 36.8 36.3 40.5 31.5 40.5 H29 Z"
        fill="url(#dasoftGrad)"
        fillRule="evenodd"
      />
      <circle cx="49.5" cy="16.5" r="3.4" fill="#F8FAFC" />
      <path d="M49.5 20.5 V27" stroke="#38BDF8" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo() {
  return (
    <img
      src="/dasoft-logo.png"
      alt="DASOFT SRL — D'Angel Software Electronic SRL"
      className="h-10 w-auto dark:rounded-lg dark:bg-white dark:px-3 dark:py-2"
    />
  );
}
